module.exports = __webpack_public_path__ + "h5/img/help-icon2.e68b2234.png";